import React from "react";
import "./Review.css";
function Review({ score }) {
  return (
    <div className="list-group">
      <div className="review">
        <span
          className="list-group-item list-group-item-action active"
          aria-current="true"
          id="qns"
        >
          <h2>Result</h2>
        </span>
        <span className="list-group-item list-group-item-action">
          <h1>{`Your Score is ${score}`}</h1>
          <a href="/">
            <button type="button" className="btn btn-primary" id="btn1">
              Attempt Again
            </button>
          </a>
        </span>
      </div>
    </div>
  );
}

export default Review;
